import useReportPackageContext from "src/frontend/components/OS/Applications/Reports/Packages/Viewer/ReportPackageContext"

export function useIsInsideReport() {
  // TODO: use props or some other way to add/hide buttons
  const { reportPackage } = useReportPackageContext()
  return !!reportPackage?.id
}
